import logoIcon from 'assets/images/logo-icon.png';

// ==============================|| LOGO ICON SVG ||============================== //

const LogoIcon = () => {
  return <img src={logoIcon} alt="DrizzleX" width="30" />;
};

export default LogoIcon;
